import React from "react";
import LoginImage from "assets/images/finance_department.png";
import ForgotPasswordForm from "./forgot/ForgotPasswordForm";
import ChangePassword from "./forgot/ChangePassword";
import { useRecoilState } from "recoil";
import { LoginActiveView } from "global/LoginActiveView";
import LoginPage from "./login/LoginPage";
import ResetPassword from "./forgot/ResetPassword";

const AuthLayout = () => {
  const [loginActiveView, setLoginActiveView] = useRecoilState(LoginActiveView);

  const renderActiveView = () => {
    switch (loginActiveView) {
      case "login":
        return <LoginPage setLoginActiveView={setLoginActiveView} />;
      case "forgot-password":
        return <ForgotPasswordForm setLoginActiveView={setLoginActiveView} />;
      case "change-password":
        return <ChangePassword setLoginActiveView={setLoginActiveView} />;
      case "reset-password":
        return <ResetPassword setLoginActiveView={setLoginActiveView} />;
      default:
        return <LoginPage setLoginActiveView={setLoginActiveView} />;
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-5">{renderActiveView()}</div>
        <div className="col-md-7 d-none d-md-flex justify-content-center">
          <img
            src={LoginImage}
            alt="Login_Image"
            style={{
              maxWidth: "100%",
              height: "92%",
              borderRadius: "50px",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
